export default '7A568';
